<template>
  <div id="app">
    <router-view />
    <LastDevice v-if="$route.path !== '/login'" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { userTokenKey, deviceLocalKey } from '@/config/index';
import {
  versionInfo,
  copyright,
  userInfo,
  getDicts
} from '@/api/system';
import {
  saveDisconnect
} from '@/api/printer'
import LastDevice from '@/components/LastDevice'

export default {
  name: 'App',
  components: {
    LastDevice
  },
  computed: {
    ...mapGetters([ 'device', 'appInfo' ])
  },
  methods: {
    ...mapActions(['setVersion', 'setCopyright', 'setUser', 'setSizeConfig', 'setAppInfo', 'setDevice','setUserCenter']),
    getVersionInfo() {
      versionInfo()
      .then(res => {
        if (res) {
          this.setVersion(res)
        }
      })
    },
    getCopyright() {
      copyright()
      .then(res => {
        if (res) {
          this.setCopyright(res)
        }
      })
    },
    getUserInfo() {
      const token = this.$cookie.get(userTokenKey)
      if (!token) return

      userInfo()
      .then(res => {
        if (res) {
          this.setUser(res)
        }
      })
    },
    getTagSizeConfig() {
      const token = this.$cookie.get(userTokenKey)
      if (!token) return

      getDicts([604])
      .then(res => {
        if (res && res[604]) {
          this.setSizeConfig(res[604])
        }
      })
    },
    getAppInfo() {
      // 获取app信息
      /**
       * 需要特别注意，app与H5交互时，需要在网页加载同步完成的交互可能会遇到app环境未准备好而导致无法收发消息的情况，目前采取的方案是使用如下轮询请求的方式保证此次交互顺利完成；
       */
      if (!this.appInfo || Object.keys(this.appInfo).length === 0) {
        const config = {
          event: 'getAppInfo',
          callback: this.receiveAppInfo
        }

        this.$utils.app.sendAppMsg(config)  
        
        setTimeout(() => {
          this.getAppInfo()
        }, 600)
      }
    },
    receiveAppInfo(data = {}) {
      const {
        info
      } = data
      
      this.setAppInfo(info)
    },
    printerConnectStatusChange(data) {
      const {
        info
      } = data
      const {
        status,
        device
      } = info
      
      if (status === 'disconnect') {
        const { address } = device
        if (this.device && this.device.address === address) {
          localStorage.removeItem(deviceLocalKey)
          this.setDevice({})
          this.$dialog.alert({
            title: '打印机连接已断开（如果频繁出现断连，请检查是否被其他设备占用，或重启打印机再试。）'
          })
          saveDisconnect({
            bluetooth_address: address
          })
        }
      }
    },
    registerEvents() {
      // 提前注册app调用事件
      this.$utils.app.registerEvent('deviceConnectStatusChange', this.printerConnectStatusChange)
    },
    init() {
      this.getVersionInfo()
      this.getCopyright()
      this.getUserInfo()
      this.getTagSizeConfig()
      this.registerEvents()
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.getAppInfo()
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
